import styled from 'styled-components';

import { WHITE, BLACK } from '@/styles/variables.style';

export const Section = styled.div`
  margin-bottom: ${({ open }) => (open ? '15px' : 0)};
  max-height: ${({ count, open }) => (open ? `${(count + 1) * 36 + 15}px` : '36px')};
  overflow-y: hidden;
  transition: max-height 200ms ease-in-out;

  // フッターのみ適用
  &.productsMenu {
    margin-bottom: 60px;
  }
`;

export const SectionItem = styled.div`
  align-items: center;
  display: flex;
  height: 36px;
  justify-content: space-between;
`;

export const SectionLabel = styled.h5`
  font-size: 14px;
  margin: 0;
  text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
  text-transform: uppercase;
  color: ${BLACK};

  &.footerMenu {
    color: ${WHITE};
  }
`;

export const OpenSectionButton = styled.div`
  position: relative;
  cursor: pointer;
  height: 15px;
  width: 15px;

  &.isOpened {
    &::after {
      display: block;
      content: '';
      position: absolute;
      top: 7px;
      left: 0;
      width: 15px;
      height: 1px;
      background-color: ${({ color }) => color};
      border-radius: 1px;
    }
  }

  &.isClosed {
    &::before,
    &::after {
      display: block;
      content: '';
      position: absolute;
      top: 7px;
      left: 0;
      width: 15px;
      height: 1px;
      background-color: ${({ color }) => color};
      border-radius: 1px;
    }

    &::before {
      top: 0;
      left: 7px;
      width: 1px;
      height: 15px;
    }
  }
`;

export const Linker = styled.a`
  text-decoration: none;
`;

export const SubCategories = styled.div`
  align-items: center;
  display: flex;
  height: 36px;
  justify-content: space-between;
`;

export const GroupLabel = styled.h5`
  color: #333;
  font-size: 14px;
  margin: 0 0 0 35px;
  text-transform: uppercase;

  &.footerMenu {
    color: ${WHITE};
  }
`;

export const OpenGroupButton = styled.div`
  position: relative;
  cursor: pointer;
  height: 16px;
  width: 16px;
  color: ${({ color }) => color};

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    right: 6px;
    border-top: 1px solid ${({ color }) => color};
    border-right: 1px solid ${({ color }) => color};
    height: 10px;
    width: 10px;
    transform: rotate(45deg);
  }
`;



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/Mobile/MenuOuterItem.style.js